import {CALL_API} from 'redux-api-middleware';
import {
  TEMPLATE_GET_REQUEST,
  TEMPLATE_GET_SUCCESS,
  TEMPLATE_GET_FAILURE,
} from 'common/types';
import {ENDPOINT_TEMPLATES} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

export default {
  getTemplate: (token, paramString) => {
    paramString = paramString.replace('subapplication=', 'subApplication=');
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_TEMPLATES}?${paramString}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [TEMPLATE_GET_REQUEST, TEMPLATE_GET_SUCCESS, TEMPLATE_GET_FAILURE],
      },
    };
  },
};
